function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function cov_28d4im0isi() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/FixedHeaderFooterPortalContainer.tsx";
  var hash = "7cc2acc8e3d1f38a36f8a87077aa7010bbef053f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/FixedHeaderFooterPortalContainer.tsx",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 57
        },
        end: {
          line: 39,
          column: 3
        }
      },
      "1": {
        start: {
          line: 41,
          column: 34
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "2": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 68
        }
      },
      "3": {
        start: {
          line: 45,
          column: 34
        },
        end: {
          line: 47,
          column: 3
        }
      },
      "4": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 68
        }
      },
      "5": {
        start: {
          line: 49,
          column: 33
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "6": {
        start: {
          line: 50,
          column: 39
        },
        end: {
          line: 50,
          column: 49
        }
      },
      "7": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 57,
          column: 6
        }
      },
      "8": {
        start: {
          line: 60,
          column: 33
        },
        end: {
          line: 69,
          column: 3
        }
      },
      "9": {
        start: {
          line: 61,
          column: 39
        },
        end: {
          line: 61,
          column: 49
        }
      },
      "10": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 68,
          column: 6
        }
      },
      "11": {
        start: {
          line: 72,
          column: 25
        },
        end: {
          line: 72,
          column: 35
        }
      },
      "12": {
        start: {
          line: 73,
          column: 57
        },
        end: {
          line: 73,
          column: 84
        }
      },
      "13": {
        start: {
          line: 74,
          column: 57
        },
        end: {
          line: 74,
          column: 84
        }
      },
      "14": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 88,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 41,
            column: 34
          },
          end: {
            line: 41,
            column: 35
          }
        },
        loc: {
          start: {
            line: 41,
            column: 57
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 41
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 45,
            column: 34
          },
          end: {
            line: 45,
            column: 35
          }
        },
        loc: {
          start: {
            line: 45,
            column: 57
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 45
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 49,
            column: 33
          },
          end: {
            line: 49,
            column: 34
          }
        },
        loc: {
          start: {
            line: 49,
            column: 77
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 49
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 60,
            column: 33
          },
          end: {
            line: 60,
            column: 34
          }
        },
        loc: {
          start: {
            line: 60,
            column: 77
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 60
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        loc: {
          start: {
            line: 71,
            column: 18
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 71
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 15
          }
        }, {
          start: {
            line: 42,
            column: 19
          },
          end: {
            line: 42,
            column: 67
          }
        }],
        line: 42
      },
      "1": {
        loc: {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 15
          }
        }, {
          start: {
            line: 46,
            column: 19
          },
          end: {
            line: 46,
            column: 67
          }
        }],
        line: 46
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7cc2acc8e3d1f38a36f8a87077aa7010bbef053f"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_28d4im0isi = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_28d4im0isi();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import Measure from 'react-measure';
import "./FixedHeaderFooterPortalContainerStyle.css";

/** @deprecated */
var FixedHeaderFooterPortalContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(FixedHeaderFooterPortalContainer, _React$Component);

  var _super = _createSuper(FixedHeaderFooterPortalContainer);

  function FixedHeaderFooterPortalContainer() {
    var _this;

    _classCallCheck(this, FixedHeaderFooterPortalContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", (cov_28d4im0isi().s[0]++, {
      footerDimensions: {
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0
      },
      headerDimensions: {
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0
      }
    }));

    _defineProperty(_assertThisInitialized(_this), "updateFooterDimensions", (cov_28d4im0isi().s[1]++, function (rect) {
      cov_28d4im0isi().f[0]++;
      cov_28d4im0isi().s[2]++;
      (cov_28d4im0isi().b[0][0]++, rect.bounds) && (cov_28d4im0isi().b[0][1]++, _this.setState({
        footerDimensions: rect.bounds
      }));
    }));

    _defineProperty(_assertThisInitialized(_this), "updateHeaderDimensions", (cov_28d4im0isi().s[3]++, function (rect) {
      cov_28d4im0isi().f[1]++;
      cov_28d4im0isi().s[4]++;
      (cov_28d4im0isi().b[1][0]++, rect.bounds) && (cov_28d4im0isi().b[1][1]++, _this.setState({
        headerDimensions: rect.bounds
      }));
    }));

    _defineProperty(_assertThisInitialized(_this), "renderFooterContainer", (cov_28d4im0isi().s[5]++, function (_ref) {
      var measureRef = _ref.measureRef;
      cov_28d4im0isi().f[2]++;

      var _ref2 = (cov_28d4im0isi().s[6]++, _this.props),
          fixedFooterContainerId = _ref2.fixedFooterContainerId;

      cov_28d4im0isi().s[7]++;
      return /*#__PURE__*/React.createElement("div", {
        className: "od-fixed-header-footer-portal-container-footer",
        id: fixedFooterContainerId,
        ref: measureRef
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "renderHeaderContainer", (cov_28d4im0isi().s[8]++, function (_ref3) {
      var measureRef = _ref3.measureRef;
      cov_28d4im0isi().f[3]++;

      var _ref4 = (cov_28d4im0isi().s[9]++, _this.props),
          fixedHeaderContainerId = _ref4.fixedHeaderContainerId;

      cov_28d4im0isi().s[10]++;
      return /*#__PURE__*/React.createElement("div", {
        className: "od-fixed-header-footer-portal-container-header",
        id: fixedHeaderContainerId,
        ref: measureRef
      });
    }));

    return _this;
  }

  _createClass(FixedHeaderFooterPortalContainer, [{
    key: "render",
    value: function render() {
      cov_28d4im0isi().f[4]++;

      var _ref5 = (cov_28d4im0isi().s[11]++, this.props),
          children = _ref5.children;

      var _ref6 = (cov_28d4im0isi().s[12]++, this.state.footerDimensions),
          footerHeight = _ref6.height,
          footerWidth = _ref6.width;

      var _ref7 = (cov_28d4im0isi().s[13]++, this.state.headerDimensions),
          headerHeight = _ref7.height,
          headerWidth = _ref7.width;

      cov_28d4im0isi().s[14]++;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Measure, {
        bounds: true,
        onResize: this.updateHeaderDimensions
      }, this.renderHeaderContainer), /*#__PURE__*/React.createElement("div", {
        style: {
          minHeight: headerHeight,
          minWidth: headerWidth
        }
      }), children, /*#__PURE__*/React.createElement(Measure, {
        bounds: true,
        onResize: this.updateFooterDimensions
      }, this.renderFooterContainer), /*#__PURE__*/React.createElement("div", {
        style: {
          minHeight: footerHeight,
          minWidth: footerWidth
        }
      }));
    }
  }]);

  return FixedHeaderFooterPortalContainer;
}((React.Component));

export { FixedHeaderFooterPortalContainer as default };